export default `/* Ids Toast Container Component */
:host(ids-toast-message) {
  --toast-message-duration: 6000ms;
  display: block;
}

.ids-toast-message {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: relative;
  z-index: var(--ids-z-index-toast);
  background-color: var(--ids-toast-color-background);
  box-sizing: border-box;
  border: 1px solid var(--ids-toast-color-border);
  border-radius: var(--ids-border-radius-2xs);
  color: var(--ids-toast-color-text);
  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);
  font-size: var(--ids-font-size-sm);
  font-weight: var(--ids-font-weight-normal);
  line-height: var(--ids-line-height-20);
  outline: 0;
}
.ids-toast-message.audible {
  /* stylelint-disable-next-line property-no-deprecated */
  clip: rect(0, 0, 0, 0);
  height: 0;
  line-height: 0;
  min-height: 0;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}
.ids-toast-message.effect-scale {
  animation: animScale 0.25s;
}
.ids-toast-message.effect-scale-hide {
  animation: animScaleOut 0.25s;
}
.ids-toast-message .main-container {
  display: flex;
}
.ids-toast-message .main-container .content-container {
  margin-block-end: var(--ids-space-12);
  margin-block-start: var(--ids-space-sm);
  margin-inline-start: var(--ids-space-12);
  padding-block-end: var(--ids-space-4xs);
  flex-grow: 1;
}
.ids-toast-message .main-container .close-button-container {
  flex-grow: 0;
  margin: var(--ids-space-4xs);
}
.ids-toast-message .title {
  color: var(--ids-toast-color-text-secondary);
  display: flex;
  font-weight: var(--ids-font-weight-semibold);
  gap: 6px;
  align-items: center;
}
.ids-toast-message .message {
  display: block;
  margin-block-start: var(--ids-space-xs);
}
.ids-toast-message .close-button::part(button) {
  margin-left: auto;
}
.ids-toast-message .progress-bar {
  background-color: var(--ids-toast-progress-color-background);
  height: 3px;
  overflow: hidden;
  width: 0;
}
.ids-toast-message .progress-bar.running {
  animation: progressBarUpdate;
  animation-play-state: running;
  animation-duration: var(--toast-message-duration);
  animation-timing-function: linear;
}
.ids-toast-message .progress-bar.running.paused {
  animation-play-state: paused;
}
.ids-toast-message .progress-bar.hidden {
  height: 0;
}

@keyframes animScale {
  0% {
    transform: translate3d(0, 40px, 0) scale3d(0.1, 0.6, 1);
    opacity: 0;
  }
  100% {
    transform: translate3d(0, 0, 0) scale3d(1, 1, 1);
    opacity: 1;
  }
}
@keyframes animScaleOut {
  0% {
    transform: translate3d(0, 0, 0) scale3d(1, 1, 1);
    opacity: 1;
  }
  100% {
    transform: translate3d(0, 40px, 0) scale3d(0.1, 0.6, 1);
    opacity: 0;
  }
}
@keyframes progressBarUpdate {
  0% {
    width: 100%;
  }
  100% {
    width: 0%;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
